module.exports = __webpack_public_path__ + "static/media/RightArrow.3d72d415.svg";